import * as yup from 'yup'

export class CompanyAttorneyInformationDto {
  attorneySignatureFileName?: string = undefined
  signatureFile?: File = undefined
}

export const companyAttorneyInformationValidationSchema = yup.object({
  signatureFile: yup
    .mixed()
    // @ts-ignore
    .test('Signature is required.', 'File ', (value: File) => value)
    .required('Signature is required.')
})
